/** Shared palette for pie slices (chat + admin). */
export const EMCURE_PIE_COLORS = [
  "#1E40AF",
  "#7C3AED",
  "#059669",
  "#B90005",
  "#F59E0B",
  "#0891B2",
  "#EC4899",
  "#8B5CF6",
  "#10B981",
  "#F97316",
];

/** Pie charts are only supported for this many categories (inclusive). */
export const MIN_PIE_SLICES = 2;
export const MAX_PIE_SLICES = 10;

export function isPieChartEligible(pointCount) {
  const n = Number(pointCount);
  return Number.isFinite(n) && n >= MIN_PIE_SLICES && n <= MAX_PIE_SLICES;
}

/** Bar / line always; pie only when slice count is 2–10. */
export const CHART_TYPE_OPTIONS = [
  { type: "bar", label: "Bar Chart" },
  { type: "line", label: "Line Chart" },
  { type: "pie", label: "Pie Chart", pieOnly: true },
];

export function getChartTypeOptionsForPointCount(pointCount) {
  const pieOk = isPieChartEligible(pointCount);
  return CHART_TYPE_OPTIONS.filter((opt) => !opt.pieOnly || pieOk);
}

/** Cartesian charts in chat bubbles — extra left space for Y-axis + angled X labels. */
export const EMCURE_CHAT_CARTESIAN_MARGIN = {
  top: 20,
  right: 30,
  left: 20,
  bottom: 65,
};

export const EMCURE_CHAT_Y_AXIS_WIDTH = 110;

/**
 * Converts a raw database column name into a human-readable tooltip label.
 *
 * Examples:
 *   "yearmn"       → "Value"
 *   "total_sales"  → "Total Sales"
 *   "hq_name"      → "HQ Name"
 *   "message_count"→ "Message Count"
 *   "yearmonth"    → "Value"
 *   "yr_mn"        → "Value"
 */
export function humanizeColumnLabel(colName) {
  if (!colName) return "Value";

  const lower = colName.toLowerCase().trim();

  // Known date/time-like column names that are actually used as numeric values
  // These should show a generic "Value" label instead of the confusing column name
  const dateishPatterns = [
    "yearmn",
    "yearmonth",
    "year_month",
    "yr_mn",
    "yrmon",
    "yr_month",
    "yearmon",
    "year_mn",
    "yyyymm",
    "yymm",
  ];
  if (dateishPatterns.includes(lower)) {
    return "Value";
  }

  // Convert snake_case / camelCase to Title Case
  let label = colName
    // Insert space before uppercase letters in camelCase
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    // Replace underscores and hyphens with spaces
    .replace(/[_-]+/g, " ")
    .trim();

  // Title case each word
  label = label
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

  return label || "Value";
}
